export const executeOnCaptchaSuccess = (callback) => {
	// Execute the captcha
	// The user might need to do a manual check
	const executeCaptcha = new CustomEvent("executeCaptcha");
	document.dispatchEvent(executeCaptcha);

	const sendAlertHandler = async () => {
		// Call the callback
		callback();

		// Reset the captcha
		const resetCaptcha = new CustomEvent("resetCaptcha");
		document.dispatchEvent(resetCaptcha);

		// Remove the event handler to execute when the captcha is done
		document.removeEventListener("captchaDone", sendAlertHandler);
	};

	// Add the event handler to execute when the captcha is done
	document.addEventListener("captchaDone", sendAlertHandler);
}
